export const VDS_ZINDEX = {
  TOOLTIP: 5000,
  MODAL: 1020,
  DRAWER: 1010,
  POP_UP: 1010,
  DROPDOWN: 100,
  FLOATING_BUTTON: 2,
  STICKY: 3,
} as const;
